import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const testimonials = [
  {
    quote: "Creative, meticulous, and seamless from start to finish.",
    name: "Arushi Sharma",
    title: "Senior Marketing Manager, The Face Shop"
  },
  {
    quote: "They delivered within constraints without compromising on quality.",
    name: "Netijyata",
    title: "La Fervance"
  },
  {
    quote: "Their ability to transform a concept into a full experience is unmatched.",
    name: "Club Jolies",
    title: "by Aditya Birla Group"
  },
  {
    quote: "It did not feel like an event. It felt like us.",
    name: "Mr. and Mrs. Sharma",
    title: ""
  }
];

export default function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      data-testid="testimonials-section"
      ref={ref}
      className="bg-[#EFEAE6] py-20 md:py-32 px-6 md:px-16 lg:px-24"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
        >
          <span className="label-text" data-testid="testimonials-label">Client Feedback</span>
          <div className="editorial-line mt-4 mb-12 md:mb-16" />
        </motion.div>

        {/* Card grid: 2 cols mobile, 4 cols desktop */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="rounded-xl px-5 py-6 md:px-6 md:py-8 text-center flex flex-col justify-between"
              style={{
                background: 'linear-gradient(160deg, rgba(255,255,255,0.55) 0%, rgba(239,234,230,0.4) 100%)',
                boxShadow: '0 3px 12px rgba(10,10,10,0.03), inset 0 1px 0 rgba(255,255,255,0.5)',
              }}
            >
              <blockquote className="font-serif text-[13px] sm:text-sm md:text-[15px] italic leading-[1.7] text-[#0A0A0A]/65 tracking-tight">
                "{t.quote}"
              </blockquote>
              <div className="mt-5 pt-4 border-t border-[#0A0A0A]/5">
                <p className="text-[9px] sm:text-[10px] tracking-[0.2em] uppercase font-light text-[#0A0A0A]/50">
                  {t.name}
                </p>
                {t.title && (
                  <p className="text-[8px] sm:text-[9px] tracking-[0.1em] text-[#8C8C8C]/60 mt-1 font-light">
                    {t.title}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
